import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateTimeService, HOUR_AS_SECONDS } from 'i2g-ng-utils';

@Pipe({
  name: 'friendlyDuration',
})
export class FriendlyDurationPipe implements PipeTransform {
  constructor(
    private _dateTimeService: DateTimeService,
    private _translateService: TranslateService
  ) {}

  transform(seconds: number): string {
    let format = this._translateService.instant('TIME.DURATION.MINUTES_FORMAT');

    if (seconds >= HOUR_AS_SECONDS) {
      format =
        (seconds / 60) % 60 === 0
          ? this._translateService.instant('TIME.DURATION.HOURS_SHORT_FORMAT')
          : this._translateService.instant('TIME.DURATION.HOURS_FORMAT');
    }

    return this._dateTimeService.formatDuration(seconds, format);
  }
}
